import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Dimmer, Loader, Confirm, Dropdown } from "semantic-ui-react";
import ActivityPanel from "../../components/ActivityPanel";
import ItemViewer from "../../components/ItemViewer";
import * as actionCreators from "../../../redux/actions/index";
import CreateUpdateModal from "./CreateUpdateBuildingModal";
import DetailsViewerModal from "./DetailsViewerModal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useHistory } from "react-router-dom";
import { toQueryString } from "../../../utilities/helper";

const BuildingsFragment = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { loading, buildings } = useSelector((state) => state.buildings);
  const [query, setQuery] = useState({ limit: 20, skip: 0 });
  const { landlords } = useSelector((state) => state.landlords);
  const [pageNumber, setPageNumber] = useState(0);

  const [values, setValues] = useState({
    buildingsListTemp: [],
    showEditModal: false,
    showViewModal: false,
    showDeletePopUp: false,
    selectMultiple: false,
    buildingToBeUpdated: undefined,
    buildingToBeShown: undefined,
    itemsTobeDeleted: {},
  });

  const {
    buildingsListTemp,
    showViewModal,
    showDeletePopUp,
    showEditModal,
    selectMultiple,
    itemsTobeDeleted,
    buildingToBeShown,
    buildingToBeUpdated,
  } = values;

  const setData = () => {
    setValues({
      ...values,
      buildingsListTemp: buildings,
    });
    console.log(buildings);
  };

  useEffect(() => {
    buildings && setData();
    console.log("buildings effect");
  }, [buildings]);

  useEffect(() => {
    dispatch(actionCreators.getLandlords());
  }, []);

  useEffect(() => {
    const queryParams = toQueryString(query);
    history.push(`/buildings${queryParams}`);
    dispatch(actionCreators.getBuildings(query));
  }, [query]);

  const onModalClose = () => {
    setValues({
      ...values,
      showEditModal: false,
      showViewModal: false,
      buildingToBeUpdated: undefined,
      buildingToBeShown: undefined,
    });
  };

  const createNewBuilding = ({ data }) => {
    console.log("Dispatching createBuilding");
    dispatch(actionCreators.createBuilding(data));
  };

  const updateBuildingData = ({ data }) => {
    console.log("Dispatching updateBuilding");
    dispatch(actionCreators.updateBuilding(data));
  };

  const onCreateOrEdit = ({ mode, data }) => {
    if (data.name === "" || data.landlord === "" || data.address === "") {
      toast("Please fill the required fields");
    } else {
      onModalClose();
      switch (mode) {
        case "edit":
          updateBuildingData({ data: data });
          return;
        case "create":
          createNewBuilding({ data: data });
          return;
        default:
          console.log(mode);
          console.log(data);
          return;
      }
    }
  };

  const onAddClick = () => {
    setValues({
      ...values,
      showEditModal: true,
    });
  };

  const onItemClick = (index) => {
    if (selectMultiple) {
      let items = { ...itemsTobeDeleted };
      if (itemsTobeDeleted[index]) {
        delete items[index];
      } else {
        items = { ...itemsTobeDeleted, [index]: buildingsListTemp[index]._id };
      }
      setValues({
        ...values,
        itemsTobeDeleted: items,
      });
    } else {
      setValues({
        ...values,
        buildingToBeShown: buildingsListTemp[index],
        showViewModal: true,
      });
    }
    console.log("item click", index);
  };

  const onEditItem = (index) => {
    console.log("edit click", index);
    setValues({
      ...values,
      buildingToBeUpdated: buildingsListTemp[index],
      showEditModal: true,
    });
  };

  const onDeleteItem = () => {
    console.log("delete confirmed", itemsTobeDeleted);
    if (Object.entries(itemsTobeDeleted).length === 0) {
      toast("No item selected");
    } else {
      let deleteIds = [];
      for (const [key, value] of Object.entries(itemsTobeDeleted)) {
        deleteIds = [...deleteIds, value];
        // console.log(key,value)
      }
      dispatch(actionCreators.deleteBuildingAsList(deleteIds));
      console.log("delete ids", deleteIds);
      setValues({
        ...values,
        showDeletePopUp: false,
        itemsTobeDeleted: {},
        selectMultiple: false,
      });
    }
  };

  const onSearch = ({ key, value }) => {
    setQuery({
      ...query,
      [key]: value,
    });
  };

  // const onSearch = (text) => {
  //   if (text === "" || text == null) {
  //     setData();
  //   } else {
  //     text = text.toLowerCase();
  //     setValues({
  //       ...values,
  //       buildingsListTemp: buildings.filter((building) => {
  //         var res1 = building.landlord.name.toLowerCase().match(text);
  //         var res2 = building.name.toLowerCase().match(text);
  //         return res1 == null && res2 == null ? false : true;
  //       }),
  //     });
  //   }
  // };

  const buildSecondaryText = (building) => {
    const {
      flat_count,
      store_count,
      flat_electricity_unit_price,
      store_electricity_unit_price,
    } = building;
    return `ফ্ল্যাটঃ ${flat_count} টি, দোকানঃ ${store_count} টি, বিদ্যুৎ ইউনিট (ফ্ল্যাট): ${flat_electricity_unit_price} টাকা, বিদ্যুৎ ইউনিট (দোকান): ${store_electricity_unit_price} টাকা।`;
  };

  return (
    <div className="parentContainer">
      <ActivityPanel
        title="Buildings"
        hideSearch
        onAddClick={onAddClick}
        onChange={(value) => onSearch({ key: "name", value: value })}
        placeholder="Search by house name..."
        extra={
          <>
            <Dropdown
              placeholder="Select landlord"
              fluid
              search
              selection
              clearable
              value={query?.landlord ?? undefined}
              onChange={(e, { value }) => {
                // onFilterBuilding(value);
                onSearch({ key: "landord", value: value });
              }}
              options={landlords?.map((item, index) => ({
                text: item?.name,
                value: item?._id,
                key: item?._id,
              }))}
            />
          </>
        }
      />
      <div style={{ alignSelf: "flex-start" }}>
        {selectMultiple && (
          <Button
            onClick={() => {
              setValues({
                ...values,
                selectMultiple: false,
                itemsTobeDeleted: {},
              });
            }}
          >
            Cancel
          </Button>
        )}
        <Button
          onClick={() => {
            if (selectMultiple) {
              setValues({ ...values, showDeletePopUp: true });
            } else {
              setValues({ ...values, selectMultiple: !selectMultiple });
            }
          }}
          color={selectMultiple && "red"}
        >
          {selectMultiple ? "Delete all" : "Delete multiple"}
        </Button>
      </div>
      <div style={{ height: "50px", alignSelf: "flex-end" }}>
        {!selectMultiple && (
          <div>
            <Button
              disabled={pageNumber === 0}
              onClick={() => {
                setPageNumber(pageNumber !== 0 ? pageNumber - 1 : 0);
                setQuery({ ...query, skip: pageNumber * query.limit });
              }}
            >
              Previous
            </Button>
            <Button
              disabled={
                buildings.length === 0 || buildings.length < query.limit
              }
              onClick={() => {
                buildings.length !== 0 && setPageNumber(pageNumber + 1);
                setQuery({ ...query, skip: (pageNumber + 1) * query.limit });
              }}
            >
              Next
            </Button>
          </div>
        )}
      </div>
      {loading ? (
        <span class="loader"></span>
      ) : buildingsListTemp.length === 0 ? (
        <p>No buildings to show</p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column" }}>
          {buildingsListTemp.map((building, index) => (
            <ItemViewer
              index={index + pageNumber * query.limit}
              primaryText={`${building.name} - ${building.landlord?.name}`}
              selectMultiple={selectMultiple}
              isSelected={itemsTobeDeleted[index] ? true : false}
              secondaryText={buildSecondaryText(building)}
              onItemClick={onItemClick}
              onEdit={onEditItem}
              onDelete={() => {
                setValues({
                  ...values,
                  itemsTobeDeleted: {
                    ...itemsTobeDeleted,
                    [index]: building._id,
                  },
                  showDeletePopUp: true,
                });
              }}
            />
          ))}
        </div>
      )}
      {showEditModal && (
        <CreateUpdateModal
          showModal={showEditModal}
          onModalClose={onModalClose}
          data={buildingToBeUpdated}
          onSubmit={onCreateOrEdit}
          landlords={landlords}
        />
      )}
      {showViewModal && (
        <DetailsViewerModal
          showModal={showViewModal}
          onModalClose={onModalClose}
          building={buildingToBeShown}
        />
      )}
      <Dimmer active={false}>
        <Loader>Working on it</Loader>
      </Dimmer>
      <ToastContainer />
      <Confirm
        open={showDeletePopUp}
        confirmButton="Yes,delete "
        cancelButton="No,leave it"
        onConfirm={() => onDeleteItem()}
        onCancel={() =>
          setValues({
            ...values,
            itemsTobeDeleted: {},
            showDeletePopUp: false,
            selectMultiple: false,
          })
        }
      />
    </div>
  );
};

export default BuildingsFragment;
